/**
 * Build and download a CSV in the browser, from rows the page already has.
 *
 * The practice works off printed and emailed lists (comparison doc P1-10), so
 * every list exports what it is showing -- filters applied -- not a different
 * server-side report that could disagree with the screen.
 *
 * Excel-friendly: a UTF-8 BOM so accented names survive, CRLF line ends, and
 * every field quoted. A cell that starts with = + - @ (and is not simply a
 * number) is prefixed with an apostrophe so a spreadsheet does not execute it
 * as a formula (CSV injection).
 */

function field(value: string): string {
  const isNumber = /^-?\d+(\.\d+)?$/.test(value)
  const safe = !isNumber && /^[=+\-@\t\r]/.test(value) ? `'${value}` : value
  return `"${safe.replace(/"/g, '""')}"`
}

export function toCsv(header: string[], rows: string[][]): string {
  return [header, ...rows].map((row) => row.map(field).join(',')).join('\r\n') + '\r\n'
}

export function downloadCsv(filename: string, header: string[], rows: string[][]): void {
  const blob = new Blob(['﻿' + toCsv(header, rows)], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
